import type { LocalePack } from '../types.js';

/**
 * Handle parts as French users compose them: a standalone nick word
 * ("loulou", "ptitecerise"), or adjective + noun ("petitelune",
 * "renardnoir"), optionally followed by a département number ("_93").
 * All lowercase ASCII-safe after folding; non-sexual.
 */
export const FR_HANDLES: LocalePack['handle'] = {
  words: [
    'loulou', 'choupette', 'minette', 'titi', 'bichette', 'ptitecerise', 'kiki', 'doudou', 'roi', 'reine',
    'bg', 'frerot', 'choupi', 'nounours', 'poupette', 'loupiot', 'chouchou', 'pupuce', 'mimi', 'lili',
    'nana', 'zizou', 'ptitloup', 'bebou', 'boubou', 'cacahuete', 'crevette', 'patate', 'pitchoune', 'puce',
    'ptitange', 'cookie', 'brioche', 'tartine', 'macaron', 'praline', 'caramel', 'chocolat', 'biscotte', 'chouquette',
    'mademoiselle', 'princesse', 'gamine', 'zouzou', 'toutou', 'lascar', 'gamin', 'ptitgars', 'frangin', 'reuf',
    'sista', 'sauvageonne', 'beaugosse', 'zinzin', 'cheri', 'ninou', 'nono', 'yaya', 'lolo', 'coco',
    'kenz', 'lyly', 'nounou', 'gribouille', 'petitpois', 'pistache', 'grenadine', 'clementine', 'myrtille', 'framboise',
    'bonbon', 'sucette', 'guimauve', 'loukoum', 'ptitcoeur', 'moumoute', 'pepito', 'petitprince', 'filou', 'chipie',
  ],
  adjectives: [
    'petite', 'petit', 'douce', 'doux', 'folle', 'fou', 'sauvage', 'noire', 'noir', 'belle',
    'beau', 'jolie', 'timide', 'rebelle', 'libre', 'calme', 'grand', 'grande', 'mignonne', 'mignon',
    'dore', 'doree', 'rose', 'bleu', 'bleue', 'blanc', 'blanche', 'rouge', 'secret', 'secrete',
    'reveuse', 'reveur', 'solaire', 'lunaire', 'brave', 'tranquille', 'royal', 'royale', 'fidele', 'gentil',
  ],
  nouns: [
    'etoile', 'lune', 'chat', 'renard', 'papillon', 'soleil', 'fleur', 'rose', 'loup', 'louve',
    'perle', 'ange', 'tigre', 'tigresse', 'lionne', 'lion', 'panthere', 'colombe', 'hirondelle', 'abeille',
    'nuage', 'orage', 'ocean', 'vague', 'plume', 'cerise', 'fraise', 'peche', 'vanille', 'cannelle',
    'merveille', 'sirene', 'fee', 'bijou', 'tresor', 'diamant', 'rubis', 'saphir', 'cristal', 'comete',
    'aigle', 'faucon', 'ours', 'koala', 'panda', 'dauphin', 'chaton', 'lapin', 'biche', 'luciole',
    'brume', 'aurore', 'mistral', 'sable', 'jasmin', 'lilas',
  ],
  placeCodes: [
    { name: '75', weight: 30 }, { name: '13', weight: 26 }, { name: '69', weight: 24 }, { name: '59', weight: 22 },
    { name: '93', weight: 24 }, { name: '92', weight: 18 }, { name: '33', weight: 17 }, { name: '31', weight: 16 },
    { name: '94', weight: 16 }, { name: '95', weight: 14 }, { name: '78', weight: 14 }, { name: '91', weight: 13 },
    { name: '06', weight: 12 }, { name: '44', weight: 12 }, { name: '67', weight: 11 }, { name: '34', weight: 11 },
    { name: '76', weight: 10 }, { name: '38', weight: 10 }, { name: '62', weight: 10 }, { name: '77', weight: 12 },
    { name: '57', weight: 8 }, { name: '35', weight: 8 }, { name: '83', weight: 8 }, { name: '60', weight: 6 },
    { name: '42', weight: 6 }, { name: '68', weight: 6 }, { name: '974', weight: 6 }, { name: '45', weight: 5 },
    { name: '84', weight: 5 }, { name: '30', weight: 5 },
  ],
};
